import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import sv from './locales/sv.json';
import en from './locales/en.json';
import da from './locales/da.json';
import no from './locales/no.json';
import fi from './locales/fi.json';

const resources = {
  sv: { translation: sv },
  en: { translation: en },
  da: { translation: da },
  no: { translation: no },
  fi: { translation: fi },
};

// Custom path detector that reads language from URL path
const pathDetector = {
  name: 'path',
  lookup() {
    const path = window.location.pathname;
    const match = path.match(/^\/([a-z]{2})(\/|$)/);
    if (match) {
      const lang = match[1];
      if (['sv', 'en', 'da', 'no', 'fi'].includes(lang)) {
        return lang;
      }
    }
    return null;
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  },
};

// Add custom detector to language detector
const languageDetector = new LanguageDetector();
languageDetector.addDetector(pathDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sv',
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
